export enum CustomRequestWidgetFormValueKeys {
    INPUTSTRING = 'inputString',
    SELECTION = 'selection',
    DATE = 'date',
    TIME = 'time',
}